import axios, { Axios } from 'axios';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import MsalService from './msal.service';

class AxiosClass {
    private static instance: Axios;

    private constructor() {
        // private constructor to prevent direct instantiation
    }

    public static getInstance(): Axios {
        if (!AxiosClass.instance) {
            AxiosClass.instance = axios.create();
        }

        return AxiosClass.instance;
    }
}

const getInstance = AxiosClass.getInstance();

// Intercept http request and append the Authorizaiton header
getInstance.interceptors.request.use(
    async (request) => {
        const msalModel = await MsalService.getInstance;

        const activeAccount = msalModel.PCA.getActiveAccount();
        if (!activeAccount) {
            // No active account found. Redirecting to login.
            msalModel.PCA.loginRedirect(msalModel.AuthRequest);
            throw new Error('No active account found. Redirecting to login.');
        }

        const res = await msalModel.PCA.acquireTokenSilent({ scopes: msalModel.AuthRequest.scopes, account: activeAccount });

        const decodedToken = jwtDecode<JwtPayload>(res.idToken);
        const currentTime = Math.floor(Date.now() / 1000);

        if (!decodedToken || !decodedToken.exp || decodedToken.exp < currentTime) {
            console.log('Token is expired');
            // Handle token expiration (e.g., refresh token, redirect to login)
            await msalModel.PCA.acquireTokenRedirect({ scopes: msalModel.AuthRequest.scopes });
        } else {
            request.headers.Authorization = `Bearer ${res.idToken}`;

            if (msalModel.ImpersonatedUser) {
                request.headers.ImpersonatedUser = msalModel.ImpersonatedUser;
            }
        }

        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const AxiosService = {
    getInstance
};

export default AxiosService;
